import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import { CancelInboundMenuCode, CancelInboundReq, GetInboundDetailsItem, GetInboundDetailsReq, GetInboundsItem, GetInboundsReq } from './types'

/**
 * GR02 입고조회 화면 엔드포인트. 전부 moms-be(2.0)다 — 1.0 이 쓰던 `/api/grid/search`(MENU_CD=GR02_HEAD·GR02_ITEM),
 * `/api/internal/data/send`, `/api/common/*` 는 부르지 않는다(사유 콤보는 useGetExportCombo 가 2.0 `/api/v1/combos` 로 받는다 — LOGISPRD-14161).
 * 근거는 docs/plan/LOGISPRD-12099-gr02.md 2장(API 전수조사)·3장(2.0 API 계약).
 */
export const GET_INBOUNDS_URL = '/api/v1/get-inbounds'
export const GET_INBOUNDS_EXCEL_URL = `${GET_INBOUNDS_URL}/excel`
export const GET_INBOUND_DETAILS_URL = '/api/v1/get-inbound-details'
export const GET_INBOUND_DETAILS_EXCEL_URL = `${GET_INBOUND_DETAILS_URL}/excel`
export const CANCEL_INBOUND_URL = '/api/v1/cancel-inbound'

/** HEAD 조회 — 서버 페이징(`page`/`size`). 정렬은 서버 고정(`clsDate DESC, ordOptNo ASC`)이다. */
export const getInbounds = (params: GetInboundsReq) =>
  request.post<ApiPaginationV2<GetInboundsItem>, GetInboundsReq>(GET_INBOUNDS_URL, params)

/** ITEM 조회 — 전건, 페이징 없음. 정렬은 서버 고정(`ordOptNo ASC, actSeq ASC`)이다. */
export const getInboundDetails = (params: GetInboundDetailsReq) =>
  request.post<ApiResponseV2<{ items: GetInboundDetailsItem[] }>, GetInboundDetailsReq>(GET_INBOUND_DETAILS_URL, params)

/**
 * 입고취소. 단건 처리라 다중 선택은 호출부가 선택 행마다 순차 호출한다(계획 6단계 · R-07).
 *
 * `cutDate` 는 `yyyyMMdd` 고정이다 — HEAD 응답의 `clsDate`(`YYYY-MM-DD`)를 그대로 보내면 400 이다.
 * 호출부(useInboundInquiryScreen)가 변환해서 넘긴다.
 *
 * gr09 와 rgr20 이 같이 부른다 — 감사 로그 화면코드를 헤더로 보낸다(LOGISPRD-15996).
 */
export const cancelInbound = (params: CancelInboundReq, menuCode: CancelInboundMenuCode) =>
  request.post<ApiResponseV2<void>, CancelInboundReq>(CANCEL_INBOUND_URL, params, menuCodeHeaders(menuCode))
